<template>
    <div class="used_car_item_tabs">
        <van-tabs v-model="active" title-active-color="#2196F3" title-inactive-color="#2196F3">
            <van-tab title="档案">
                <van-cell-group>
                    <van-cell title="出厂日期" :value="item.production_date"/>
                    <van-cell title="交强险到期" :value="item.compulsory_insurance_date"/>
                    <van-cell title="商业险到期" :value="item.car_insurance_date"/>
                    <van-cell title="价格分析" :value="item.price_analysis"/>
                    <van-cell title="金融按揭" :value="item.financial_mortgage"/>
                    <van-cell title="配置亮点" :value="item.configuration"/>
                    <van-cell title="车况综述" :value="item.situation"/>
                </van-cell-group>
                <div class="imgs">
                    <van-image
                        v-for="(itm,idx) in pz_imgs"
                        :src="itm"
                        :key="idx"/>
                </div>
            </van-tab>
            <van-tab title="实车">
                <div class="images">
                    <van-image
                        v-for="(itm, idx) in sc_imgs"
                        :src="itm"
                        :key="idx"/>
                </div>
            </van-tab>
            <van-tab title="服务">
                <van-cell-group title="店铺服务套餐">
                    <van-cell
                        v-for="(itm, idx) in packitems"
                        :title="itm.name"
                        :value="itm.qty + '次'"
                        :key="idx"/>
                </van-cell-group>
            </van-tab>
            <van-tab title="保修">
                <van-cell-group>
                    <van-cell title="保修项目">
                        <van-tag
                            round
                            type="success"
                            v-for="(itm,idx) in main_projs"
                            :key="idx">
                            {{ itm }}
                        </van-tag>
                    </van-cell>
                    <van-cell title="保修时间/里程" :value="main_time + '/' + main_mileage " />
                    <van-cell title="保修说明" :value="main_note"/>
                </van-cell-group>
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
import { 
    Tabs,
    Tab,
    CellGroup,
    Cell,
    Image,
    Tag
} from 'vant'

export default {
    name: 'ItemTabs',
    components: {
        [Tabs.name]: Tabs,
        [Tab.name]: Tab,
        [CellGroup.name]: CellGroup,
        [Cell.name]: Cell,
        [Tag.name]: Tag,
        [Image.name]: Image
    },
    data() {
        return {
            active: 0,
            item: {},
            packitems: [], // 店铺服务套餐
            pz_imgs: [], // 配置图
            sc_imgs: [], // 实车图
            // maintenance: [], // 经销商维保
            main_projs: [], // 保修项目
            main_time: '', // 保修里程时间
            main_mileage: '', // 保修里程时间
            main_note: '' // 保修说明
        }
    },
    methods: {
        refresh(data) {
            console.log('refresh')
            console.log(data)
            this.item = data
            console.log(this.packitems)
            console.log(this.item.used_car_shop.package.servers)
            console.log(this.item.used_car_shop.package.versions)
            this.packitems = [...this.item.used_car_shop.package.servers,...this.item.used_car_shop.package.versions]
            console.log(this.packitems)
            this.pz_imgs = this.item.imgs.filter((i) => i.style === 2).map((it) => it.img)
            this.sc_imgs = this.item.imgs.filter((i) => i.style === 1).map((it) => it.img)
            if (data.maintenance.length>0 && data.maintenance[0].content != null) {
                this.main_projs = (data.maintenance[0].content).split(";")
            }
            if (data.maintenance.length>1 && data.maintenance[1].content != null) {
                this.main_time = data.maintenance[1].content
            }
            if (data.maintenance.length>2 && data.maintenance[2].content != null) {
                this.main_mileage = data.maintenance[2].content
            }
            if (data.maintenance.length>3 && data.maintenance[3].content != null) {
                this.main_note = data.maintenance[3].content
            }
            // console.log(data.maintenance.length>1)
            // console.log(data.maintenance[0].content)
            // console.log(data.maintenance[0].content.split(";"))
            // if (this.item.maintenance.filter((e)=>e.style=10).length>0) {
            //     this.main_projs = this.item.maintenance.filter((e)=>e.style=10)[0].content
            // }
            // if (this.item.maintenance.filter((e)=>e.style=20).length>0) {
            //     this.main_time = this.item.maintenance.filter((e)=>e.style=20)[0].content
            // }
            // if (this.item.maintenance.filter((e)=>e.style=30).length>0) {
            //     this.main_mileage = this.item.maintenance.filter((e)=>e.style=30)[0].content
            // }
            // if (this.item.maintenance.filter((e)=>e.style=40).length>0) {
            //     this.main_note = this.item.maintenance.filter((e)=>e.style=40)[0].content
            // }
            console.log(this.main_projs)
            // console.log(this.main_time)
            // console.log(this.main_mileage)
            // console.log(this.main_note)
        }
    }
}
</script>

<style lang="less">
.used_car_item_tabs {
    .van-tabs__line {
        background-color: #2196F3;
    }
}
</style>
